import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;
/**
 * 获取轮询图
 * @returns
 */
export const getCarouseImg = (pageNum = 1, pageSize = 1000): Promise<Array<any>> => {
    return axios.get(`${baseURL}/CarouseImg?pageNum=${pageNum}&pageSize=${pageSize}&carouselmgType=1`)
}
/**
 * 获取产品列表
 * @returns
 */
export const getProductList = (productType: number, pageNum = 1, pageSize = 1000, productClassifyId: string): any => {
    return axios.get(`${baseURL}/Product?productType=${productType}&pageNum=${pageNum}&pageSize=${pageSize}&productClassifyId=${productClassifyId}`)
}
/**
 * 获取产品分类
 * @returns
 */
export const getProductClassify = (count: number): any => {
    return axios.get(`${baseURL}/ProductClassify?count=${count}`)
}

/**
 * 获取标签栏
 * @returns
 */
export const getProductTag = (productType: number): any => {
    return axios.get(`${baseURL}/ProductClassify/ComboBox?productType=${productType}`)
}
/**
 * 获取产品详情
 * @returns
 */
export const getDetail = (id: string): any => {
    return axios.get(`${baseURL}/Product/${id}`)
}
/**
 * 搜索页面
 * @returns
 */
export const searchProduct = (name: string, pageNum: number, pageSize: number): any => {
    return axios.get(`${baseURL}/Product?name=${name}&pageNum=${pageNum}&pageSize=${pageSize}`)
}
/**
 * 加入购物车
 * @returns
 */
export const addCart = (obj: any): any => {
    return axios.post(`${baseURL}/ShoppingCart`, obj)
}
/**
 * 购物车列表
 * @returns
 */
export const getCartList = (): any => {
    return axios.get(`${baseURL}/ShoppingCart`)
}
/**
 * 编辑购物车
 * @returns
 */
export const editCart = (obj: any): any => {
    return axios.put(`${baseURL}/ShoppingCart/UpdateNum `, obj)
}
/**
 * 获取商品列表
 * @returns
 */
 export const getPreferentialActivities = (obj: any): any => {
    return axios.get(`${baseURL}/PreferentialActivities`, {
        params: obj
    })
}
/**
 * 拼团其他的拼团商品
 * @param obj 
 * @returns 
 */
export const getAppExcludeProduct = (obj: any): any => {
    return axios.get(`${baseURL}/PreferentialActivities/AppExcludeProduct`, {
        params: obj
    })
}
/**
 * 获取优惠列表
 * @returns
 */
export const getHomePageActivitiesProduct = (obj: any): any => {
    return axios.get(`${baseURL}/PreferentialActivities/HomePageActivitiesProduct`, {
        params: obj
    })
}

/**
 * 通过活动商品id 获取活动商品详情
 * @returns
 */
 export const getActivitiesProductDetailById = (obj: any): any => {
    return axios.get(`${baseURL}/Product/ActivitiesProductDetailById`, {
        params: obj
    })
}
/**
 * 成团||拼团
 * @returns
 */
export const postLump = (obj: any): any => {
    return axios.post(`${baseURL}/Lump`, obj)
}
/**
 * 删除购物车的商品
 * @returns
 */
export const deleteCart = (id: string): any => {
    return axios.delete(`${baseURL}/ShoppingCart/${id}`)
}

/**
 * 获取客服联系方式
 * 已过时
 * @returns
 */
// export const getPhone = (): any => {
//     return axios.get(`${baseURL}/Gods/CustomerService/ServicePersonnel`)
// }

/**
 *地址列表
 * @returns
 */
export const getAddress = (): any => {
    return axios.get(`${baseURL}/ShippingAddress`)
}
/**
 * 新增地址
 * @returns
 */
export const addAddress = (obj: any): any => {
    return axios.post(`${baseURL}/ShippingAddress`, obj)
}
/**
 * 编辑地址
 * @returns
 */
export const editAddress = (obj: any): any => {
    return axios.put(`${baseURL}/ShippingAddress`, obj)
}
/**
 * 设置默认地址
 * @returns
 */
export const setDefaultAddress = (obj: any): any => {
    return axios.put(`${baseURL}/ShippingAddress/Default`, obj)
}
/**
 * 获取默认地址
 * @returns
 */
export const getDefaultAddress = (): any => {
    return axios.get(`${baseURL}/ShippingAddress/GetDefault`)
}
/**
 * 获取地址详情
 * @returns
 */
export const getAddressDetail = (id: string): any => {
    return axios.get(`${baseURL}/ShippingAddress/${id}`)
}
/**
 * 删除地址
 * @returns
 */
export const deleteAddress = (id: string): any => {
    return axios.delete(`${baseURL}/ShippingAddress/${id}`)
}
/**
 * 个人中心-积分
 * @returns
 */
export const getUserPoints = (): any => {
    return axios.get(`${baseURL}/UserPoints/GetShopUserPoints`)
}

/**
 * 生成订单
 * @returns
 */
export const generateOrder = (obj: any): any => {
    return axios.post(`${baseURL}/Order`, obj)
}
/**
 * 获取订单号
 * @returns
 */
export const getOrderNo = (id: string): any => {
    return axios.get(`${baseURL}/Order/DetailPay?id=${id}`)
}


/**
 * 通知那里使用，通过订单id，获取订单信息，里面有orderNo
 * @param id 订单id
 * @returns 
 */
export const getNoticeOrderNoById = (id: string): any => {
    return axios.get(`${baseURL}/Order/DetailNotice?id=${id}`)
}
/**
 * 获取确认订单产品
 * @returns
 */
export const confirmProduct = (ids: any, addressId: string, type: number, num: any, isDeductPoints:boolean): Promise<Array<any>> => {
    return axios.get(`${baseURL}/Order/PreCommit?ids=${ids}&addressId=${addressId}&type=${type}&num=${num}&isDeductPoints=${isDeductPoints}`)
}
export const confirmNewProduct = (obj:any): any  => {
    return axios.post(`${baseURL}/Order/PreNewCommit`,obj)
}
/**
 * PC 团购订单详情
 * @returns
 */
export const AppGroupBuyingDetail = (obj: any): Promise<Array<any>> => {
    return axios.get(`${baseURL}/Order/AppGroupBuyingDetail`, {
        params: obj
    })
}
/**
 * 获取关联产品列表
 * @returns
 */
export const getRelatedProduct = (id: string): any => {
    return axios.get(`${baseURL}/Product/RelevanceProductList?id=${id}`)
}
